import 'swiper/css';
import '../../scss/entry/swiper.scss';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../modules/swiper.js';
